module.exports = __webpack_public_path__ + "static/media/explore.ed328ac5.png";